<template>
  <BaseListItem v-if="edit">
    <div class="flex items-baseline -mx-4">
      <div class="flex flex-1 px-2 glue-h">
        <ValidationProvider
          name="url"
          :vid="`webPresences.${index}.url`"
          rules="required"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup class="w-full">
            <BaseFormInput
              type="url"
              v-model.lazy="computedUrl"
              :disabled="updating"
              :invalid="failed"
              placeholder="enter url..."
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>

        <ValidationProvider
          name="type"
          :vid="`webPresences.${index}.type`"
          :rules="webPresenceTypeRules"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup class="w-full">
            <BaseFormSelect
              v-model="computedType"
              :options="webPresenceTypes"
              :disabled="updating"
              :invalid="failed"
              placeholder="enter url..."
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>
      </div>
      <div class="pr-2">
        <BaseIconButton v-if="!updating" icon="trash" brand @click="$emit('destroy')" />
        <Loader v-else small />
      </div>
    </div>
  </BaseListItem>
  <BaseListItem v-else-if="updating">
    <div class="flex items-baseline -mx-4">
      <div class="flex-1 px-4 text-red-500 text-center">
        <Loader medium />
      </div>
    </div>
  </BaseListItem>
  <BaseListItem v-else>
    <div class="flex items-baseline -mx-4">
      <div class="flex-1 px-4 truncate">
        <p>
          <a :href="entity.url" target="_blank">{{ entity.url }}</a>
        </p>
        <span class="capitalize text-gray-700 text-sm">
          {{ webPresenceTypes[entity.type] }}
        </span>
      </div>
    </div>
  </BaseListItem>
</template>

<script>
export default {
  name: 'ListingItem',
  props: {
    index: {
      type: Number,
      required: true,
    },
    entity: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      default: 'trash',
    },
    edit: Boolean,
    updating: Boolean,
  },
  computed: {
    computedUrl: {
      get() {
        return this.entity.url;
      },
      set(value) {
        this.$emit('change', { ...this.entity, url: value });
      },
    },
    computedType: {
      get() {
        return this.entity.type;
      },
      set(type) {
        this.$emit('change', { ...this.entity, type });
      },
    },
    webPresenceTypes() {
      return Object.keys(this.$store.state.app.webPresenceTypes || {}).map((key) => ({
        value: key,
        label: this.$store.state.app.webPresenceTypes[key],
      }));
    },
    webPresenceTypeRules() {
      const options = this.webPresenceTypes.map((type) => type.value).join(',');
      return `required|oneOf:${options}`;
    },
  },
};
</script>
